import { render } from "./CodeIcon.vue?vue&type=template&id=331cfc6c&scoped=true"
const script = {}

import "./CodeIcon.vue?vue&type=style&index=0&id=331cfc6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331cfc6c"]])

export default __exports__